import { render, staticRenderFns } from "./EditPrinterSis.vue?vue&type=template&id=9154c968&scoped=true&"
import script from "./EditPrinterSis.vue?vue&type=script&lang=js&"
export * from "./EditPrinterSis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9154c968",
  null
  
)

export default component.exports